import { useMemo } from 'react';
import { useActiveSnippet, useActiveSnippetVersion, VersionedSnippet, VersionName } from '@cld/code-snippet-next';
import { SnippetLanguage } from '../types';

export const useSelectedSnippet = <T extends VersionedSnippet>(snippets: T[], language: SnippetLanguage | undefined, version: VersionName) => {
  const activeSnippet = useActiveSnippet(snippets, language);
  const activeVersionSnippet = useActiveSnippetVersion(version, activeSnippet);

  return useMemo(() => ({ ...activeSnippet, selectedVersionName: activeVersionSnippet?.versionName }), [activeSnippet, activeVersionSnippet.versionName]);
};
